import z from 'zod';

export enum SeedQuestionStatus {
  ACTIVE = 'ACTIVE',
  GENERATED = 'GENERATED',
  FLAGGED = 'FLAGGED',
}

export const seedQuestionStatusSchema = z.nativeEnum(SeedQuestionStatus);
